import { Component, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { HeaderComponent } from './core/components/header/header.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { CookieBannerComponent } from './core/components/cookie-banner/cookie-banner.component';
import { AnalyticsService } from './core/services/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, ToastModule, CookieBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly analytics = inject(AnalyticsService);
  private readonly currentUrl = signal<string>(this.router.url);

  readonly showChrome = computed(() => {
    const url = this.currentUrl();
    const path = url.split('?')[0];
    if (path.startsWith('/login')) return false;
    if (path.startsWith('/registrieren')) return false;
    if (path.startsWith('/onboarding')) return false;
    return true;
  });

  constructor() {
    // Stellt den Consent-Subscribe her (lädt GA4 nur nach Opt-in, sonst no-op).
    this.analytics.init();

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.currentUrl.set(e.urlAfterRedirects));
  }
}
